import store from '../store/store';
import { freeBusyCache, FreeBusyRow } from 'owa-freebusy-cache';
import { ObservableMap } from 'mobx';
import { mutator } from 'satcheljs';
import { setShowSchedulingAssistant } from '../actions/setShowSchedulingAssistant';

export default mutator(setShowSchedulingAssistant, actionMessage => {
    store.viewState.showSchedulingAssistant = actionMessage.showSchedulingAssistant;

    // TODO: migrate this out, but for now let's put it here:
    if (actionMessage.showSchedulingAssistant) {
        // initialize the F/B cache
        let freeBusyData = (store.viewState.freeBusyData = new ObservableMap<
            string,
            ObservableMap<string, FreeBusyRow>
        >({}));

        freeBusyCache.initialize(freeBusyData);
    }
});
